var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconAddComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-add ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6661 2.33427C8.6661 2.1502 8.51688 2.00098 8.3328 2.00098H7.66622C7.48215 2.00098 7.33293 2.1502 7.33293 2.33427V7.33366H2.33354C2.14946 7.33366 2.00024 7.48288 2.00024 7.66695V8.33354C2.00024 8.51761 2.14946 8.66683 2.33354 8.66683H7.33293V13.6662C7.33293 13.8503 7.48215 13.9995 7.66622 13.9995H8.3328C8.51688 13.9995 8.6661 13.8503 8.6661 13.6662V8.66683H13.6655C13.8496 8.66683 13.9988 8.51761 13.9988 8.33354V7.66695C13.9988 7.48288 13.8496 7.33366 13.6655 7.33366H8.6661V2.33427Z",
    fillOpacity: "1"
  }));
}
var IconAdd = /*#__PURE__*/React.forwardRef(IconAddComponent);
export default IconAdd;